import React, { useLayoutEffect, useRef, useState } from "react";
import {
  MdOutlineSpaceDashboard,
  MdOutlineInventory2,
  MdOutlineEventNote,
  MdOutlinePayments,
  MdOutlineLink,
  MdOutlineSettings,
  MdOutlineFreeCancellation,
  MdOutlineEmojiEvents,
  MdOutlineNewReleases,
  MdOutlinePeopleAlt,
  MdOutlineRateReview,
  MdOutlineReviews,
  MdOutlineAnalytics,
  MdOutlineMonitorHeart,
  MdOutlineWbSunny,
  MdOutlineTimer,
  MdOutlinePhoneAndroid,
  MdOutlineInsights,
  MdOutlineManageSearch,
  MdOutlineEditNote,
  MdOutlineAccountBalanceWallet,
  MdOutlineEventBusy,
  MdOutlineCategory,
  MdOutlineContentCut,
  MdOutlineLayers,
  MdOutlineLocalOffer,
  MdOutlineViewCarousel,
  MdOutlineWebAsset,
  MdOutlineHome,
  MdOutlineArticle,
  MdOutlineWidgets,
  MdOutlineAdminPanelSettings,
  MdOutlineSupportAgent,
  MdOutlineBeachAccess,
  MdOutlineCampaign,
  MdOutlineContactPhone,
  MdOutlineRequestQuote,
  MdOutlineQueryStats,
  MdOutlineAssessment,
  MdOutlineSavings,
  MdOutlineTrendingUp,
  MdExpandMore,
  MdMenu,
  MdClose,
} from "react-icons/md";
import { useLocation, Link } from "react-router-dom";
import { useAuthz } from "../auth/useAuthz";

// The admin menu, in order. An item is { label, to, icon, permission }; a
// group is { label, icon, items } and only shows if one of its items does.
const MENU = [
  { label: "Dashboard", to: "/admin/dashboard", icon: MdOutlineSpaceDashboard, permission: "dashboard.read" },
  { label: "Inventory Dashboard", to: "/admin/inventory-dashboard", icon: MdOutlineInventory2, permission: "dashboard.read" },
  { label: "Booking", to: "/admin/bookings", icon: MdOutlineEventNote, permission: "bookings.read" },
  { label: "Payments", to: "/admin/payments", icon: MdOutlinePayments, permission: "payments.read" },
  { label: "Razorpay Links", to: "/admin/razorpay-payments", icon: MdOutlineLink, permission: "payments.read" },
  {
    label: "Settings",
    icon: MdOutlineSettings,
    items: [
      { label: "Cancellation Policy", to: "/admin/cancellation-policy", icon: MdOutlineFreeCancellation, permission: "cancellationPolicy.read" },
      { label: "Rewards", to: "/admin/rewards", icon: MdOutlineEmojiEvents, permission: "rewards.read" },
      { label: "App Updates", to: "/admin/app-updates", icon: MdOutlineNewReleases, permission: "appUpdates.read" },
    ],
  },
  { label: "User Management", to: "/admin/user-management", icon: MdOutlinePeopleAlt, permission: "userManagement.read" },
  { label: "Feedback Dashboard", to: "/admin/feedback-dashboard", icon: MdOutlineRateReview, permission: "dashboard.read" },
  { label: "Customer Feedback", to: "/admin/customer-feedback", icon: MdOutlineReviews, permission: "customerFeedback.read" },
  { label: "Services Dashboard", to: "/admin/services-dashboard", icon: MdOutlineAnalytics, permission: "dashboard.read" },
  {
    label: "Monitoring",
    icon: MdOutlineMonitorHeart,
    items: [
      { label: "Daily Brief", to: "/admin/daily-brief", icon: MdOutlineWbSunny, permission: "dailyBrief.read" },
      { label: "Employee Activity", to: "/admin/employee-activity", icon: MdOutlineTimer, permission: "employeeActivity.read" },
      { label: "Professional App", to: "/admin/professional-app", icon: MdOutlinePhoneAndroid, permission: "employeeActivity.read" },
      { label: "Team Insights", to: "/admin/team-insights", icon: MdOutlineInsights, permission: "employeeActivity.read" },
      { label: "Office Activity", to: "/admin/office-activity", icon: MdOutlineManageSearch, permission: "officeActivity.read" },
      { label: "Booking Changes", to: "/admin/booking-changes", icon: MdOutlineEditNote, permission: "officeActivity.read" },
      { label: "Money Watch", to: "/admin/money-watch", icon: MdOutlineAccountBalanceWallet, permission: "moneyWatch.read" },
      { label: "Lost Demand", to: "/admin/lost-demand", icon: MdOutlineEventBusy, permission: "lostDemand.read" },
    ],
  },
  {
    label: "Catalog",
    icon: MdOutlineCategory,
    items: [
      { label: "Services", to: "/admin/services", icon: MdOutlineContentCut, permission: "services.read" },
      { label: "Service Combos", to: "/admin/service-combos", icon: MdOutlineLayers, permission: "services.read" },
      { label: "Code Management", to: "/admin/code-management", icon: MdOutlineLocalOffer, permission: "codeManagement.read" },
      { label: "Banners", to: "/admin/banners", icon: MdOutlineViewCarousel, permission: "banners.read" },
    ],
  },
  {
    label: "UI",
    icon: MdOutlineWebAsset,
    items: [
      { label: "App Home Builder", to: "/admin/home-builder", icon: MdOutlineHome, permission: "appHomeBuilder.read" },
      { label: "App Service Pages", to: "/admin/service-pages", icon: MdOutlineArticle, permission: "appServicePages.read" },
      { label: "Package Builder", to: "/admin/package-builder", icon: MdOutlineWidgets, permission: "packageBuilder.read" },
    ],
  },
  { label: "RBAC", to: "/admin/rbac", icon: MdOutlineAdminPanelSettings, permission: "rbac.read" },
  { label: "Staff Desk", to: "/admin/staff-desk", icon: MdOutlineSupportAgent, permission: "dashboard.read" },
  { label: "Leave Management", to: "/admin/leave-management", icon: MdOutlineBeachAccess, permission: "dashboard.read" },
  { label: "Campaigns", to: "/admin/campaigns", icon: MdOutlineCampaign, permission: "dashboard.read" },
  { label: "Leads", to: "/admin/leads", icon: MdOutlineContactPhone, permission: "leads.read" },
  { label: "Payouts & Payroll", to: "/admin/payouts", icon: MdOutlineRequestQuote, permission: "dashboard.read" },
  { label: "Product Analytics", to: "/admin/product-analytics", icon: MdOutlineQueryStats, permission: "analytics.read" },
  {
    label: "Reports",
    icon: MdOutlineAssessment,
    items: [
      { label: "Cash In Hand Report", to: "/admin/cash-in-hand-report", icon: MdOutlineSavings, permission: "cashinhand.read" },
      { label: "Growth Reports", to: "/admin/growth-reports", icon: MdOutlineTrendingUp, permission: "growthReports.read" },
    ],
  },
];

// The page itself or a page under it ("/admin/services/123"), but not a
// different page that only shares the prefix ("/admin/services-dashboard").
const isActive = (pathname, to) => pathname === to || pathname.startsWith(`${to}/`);

// Every admin page renders its own <Sidebar />, so moving to another page
// mounts a fresh one. These keep the scroll position and the open groups
// for the browser tab, so the menu stays where it was.
const SCROLL_KEY = "adminSidebarScroll";
const GROUPS_KEY = "adminSidebarGroups";
const readStore = (key, fallback) => {
  try {
    const v = sessionStorage.getItem(key);
    return v === null ? fallback : JSON.parse(v);
  } catch (e) {
    return fallback;
  }
};
const writeStore = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // Private mode / storage blocked: the menu just won't remember.
  }
};

const NavItem = ({ item, active, nested }) => {
  const Icon = item.icon;
  return (
    <Link
      to={item.to}
      aria-current={active ? "page" : undefined}
      data-active={active || undefined}
      className={`group relative flex items-center gap-3 rounded-lg px-3 ${nested ? "py-1.5" : "py-2"} text-[13px] transition-colors duration-150 ${
        active ? "bg-[#FBB033]/10 text-[#FBB033] font-semibold" : "text-gray-300 font-medium hover:bg-white/[0.06] hover:text-white"
      }`}
    >
      {active && <span className="absolute -left-3 top-1/2 h-5 w-1 -translate-y-1/2 rounded-r-full bg-[#FBB033]" />}
      <Icon className={`shrink-0 text-[18px] ${active ? "text-[#FBB033]" : "text-gray-500 group-hover:text-gray-200"}`} />
      <span className="truncate">{item.label}</span>
    </Link>
  );
};

// A collapsible section. Open if it holds the current page, else as the
// person last left it (closed the first time).
const NavGroup = ({ group, items, pathname }) => {
  const holdsCurrentPage = items.some((i) => isActive(pathname, i.to));
  const [open, setOpen] = useState(() => holdsCurrentPage || !!readStore(GROUPS_KEY, {})[group.label]);
  const toggle = () =>
    setOpen((v) => {
      writeStore(GROUPS_KEY, { ...readStore(GROUPS_KEY, {}), [group.label]: !v });
      return !v;
    });
  const Icon = group.icon;
  return (
    <div>
      <button
        type="button"
        onClick={toggle}
        aria-expanded={open}
        className={`group flex w-full items-center gap-3 rounded-lg px-3 py-2 text-[13px] font-medium transition-colors duration-150 hover:bg-white/[0.06] ${
          holdsCurrentPage ? "text-white" : "text-gray-300 hover:text-white"
        }`}
      >
        <Icon className={`shrink-0 text-[18px] ${holdsCurrentPage ? "text-[#FBB033]" : "text-gray-500 group-hover:text-gray-200"}`} />
        <span className="flex-1 text-left truncate">{group.label}</span>
        {!open && holdsCurrentPage && <span className="h-1.5 w-1.5 rounded-full bg-[#FBB033]" />}
        <MdExpandMore className={`shrink-0 text-lg text-gray-500 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="ml-[22px] mt-0.5 mb-1 space-y-0.5 border-l border-white/10 pl-3">
          {items.map((item) => (
            <NavItem key={item.to} item={item} nested active={isActive(pathname, item.to)} />
          ))}
        </div>
      )}
    </div>
  );
};

const Sidebar = () => {
  // Start collapsed on mobile so the menu doesn't cover page content on
  // load; desktop (lg+) always renders the full sidebar regardless of
  // this state (see the `lg:` overrides below).
  const [open, setOpen] = useState(() => typeof window !== "undefined" && window.innerWidth >= 1024);
  const { can } = useAuthz();
  const { pathname } = useLocation();

  // Put the menu back where it was scrolled to before this page loaded.
  const panelRef = useRef(null);
  useLayoutEffect(() => {
    const el = panelRef.current;
    if (!el) return;
    el.scrollTop = readStore(SCROLL_KEY, 0) || 0;
    // A first visit, or the link that brought us here is out of view.
    const active = el.querySelector("[data-active]");
    if (active) {
      const a = active.getBoundingClientRect();
      const box = el.getBoundingClientRect();
      if (a.top < box.top || a.bottom > box.bottom) active.scrollIntoView({ block: "center" });
    }
  }, []);
  const saveScroll = (e) => writeStore(SCROLL_KEY, e.currentTarget.scrollTop);

  return (
    <div className="h-full z-50 fixed inset-y-0 left-0 flex">
      {/* Mobile toggle button */}
      <button
        className="fixed lg:hidden z-50 bottom-6 left-4 bg-[#191919] w-10 h-10 rounded-full drop-shadow-lg flex justify-center items-center text-white hover:bg-[#151515] duration-300"
        onClick={() => setOpen((prev) => !prev)}
        aria-label={open ? "Close menu" : "Open menu"}
      >
        {open ? <MdClose className="text-xl" /> : <MdMenu className="text-xl" />}
      </button>

      {/* Sidebar panel */}
      <div
        ref={panelRef}
        onScroll={saveScroll}
        className={`${open ? "w-60" : "w-0"} lg:w-72 h-screen overflow-y-auto overflow-x-hidden no-scrollbar bg-[#141414] border-r border-white/[0.06] duration-300`}
      >
        {/* Logo */}
        <div className="sticky top-0 z-10 flex items-center gap-3 bg-[#141414] px-6 pt-6 pb-5">
          <img src="/Assets/barberalogo.png" className="h-9 w-auto" alt="Barbera" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gray-500">Admin</span>
        </div>

        {/* Menu */}
        <nav className={`flex-col gap-0.5 px-3 pb-10 lg:flex ${open ? "flex" : "hidden"}`}>
          {MENU.map((entry) => {
            if (entry.items) {
              const items = entry.items.filter((i) => can(i.permission));
              if (!items.length) return null;
              return <NavGroup key={entry.label} group={entry} items={items} pathname={pathname} />;
            }
            if (!can(entry.permission)) return null;
            return <NavItem key={entry.to} item={entry} active={isActive(pathname, entry.to)} />;
          })}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
